// extracted by mini-css-extract-plugin
export var measureBox = "_x-0";